import React, { useState, useEffect } from "react";

function HeartBroken({ outline = false, color = "white", size = 24 }) {
  return outline ? (
    <svg
      width={size}
      height={size}
      xmlns="http://www.w3.org/2000/svg"
      viewBox={`0 0 ${size} ${size}`}
    >
      <title>heart-broken-outline</title>
      <path
        color={color}
        fill="currentColor"
        d="M7.5,5C7.7,5 7.9,5 8.1,5.1L10.5,9.2L6.8,13.8C5.1,11.8 4,10.2 4,8.5C4,6.5 5.5,5 7.5,5M7.5,3C4.4,3 2,5.4 2,8.5C2,12.3 5.4,15.4 10.6,20L12,21.3L9,14.3L13,9.3L9.4,3.3C8.8,3.1 8.2,3 7.5,3M16.5,5C18.5,5 20,6.5 20,8.5C20,11.1 17.4,13.7 13.4,17.3L13.1,15L17.9,9.7L15.6,5.2C15.9,5 16.2,5 16.5,5M16.5,3C15.2,3 13.9,3.5 12.9,4.3L15.5,9.4L11,14.4L12,21.4L13.4,20.1C18.6,15.4 22,12.3 22,8.6C22,5.4 19.6,3 16.5,3Z"
      />
    </svg>
  ) : (
    <svg
      width={size}
      height={size}
      xmlns="http://www.w3.org/2000/svg"
      viewBox={`0 0 ${size} ${size}`}
    >
      <title>heart-broken</title>
      <path
        color={color}
        fill="currentColor"
        d="M12,21.35L10.55,20.03C5.4,15.36 2,12.27 2,8.5C2,5.41 4.42,3 7.5,3C8.17,3 8.82,3.12 9.44,3.33L13,9.35L9,14.35L12,21.35V21.35M16.5,3C19.58,3 22,5.41 22,8.5C22,12.27 18.6,15.36 13.45,20.03L12,21.35L11,14.35L15.5,9.35L12.85,4.27C13.87,3.47 15.17,3 16.5,3Z"
      />
    </svg>
  );
}

function Heart({ outline, color = "white", size = 24 }) {
  return outline ? (
    <svg
      width={size}
      height={size}
      xmlns="http://www.w3.org/2000/svg"
      viewBox={`0 0 ${size} ${size}`}
    >
      <title>heart-outline</title>
      <path
        color={color}
        fill="currentColor"
        d="M12.1,18.55L12,18.65L11.89,18.55C7.14,14.24 4,11.39 4,8.5C4,6.5 5.5,5 7.5,5C9.04,5 10.54,6 11.07,7.36H12.93C13.46,6 14.96,5 16.5,5C18.5,5 20,6.5 20,8.5C20,11.39 16.86,14.24 12.1,18.55M16.5,3C14.76,3 13.09,3.81 12,5.08C10.91,3.81 9.24,3 7.5,3C4.42,3 2,5.41 2,8.5C2,12.27 5.4,15.36 10.55,20.03L12,21.35L13.45,20.03C18.6,15.36 22,12.27 22,8.5C22,5.41 19.58,3 16.5,3Z"
      />
    </svg>
  ) : (
    <svg
      width={size}
      height={size}
      xmlns="http://www.w3.org/2000/svg"
      viewBox={`0 0 ${size} ${size}`}
    >
      <title>heart</title>
      <path
        color={color}
        fill="currentColor"
        d="M12,21.35L10.55,20.03C5.4,15.36 2,12.27 2,8.5C2,5.41 4.42,3 7.5,3C9.24,3 10.91,3.81 12,5.08C13.09,3.81 14.76,3 16.5,3C19.58,3 22,5.41 22,8.5C22,12.27 18.6,15.36 13.45,20.03L12,21.35Z"
      />
    </svg>
  );
}

export default function Feedback({
  likes,
  deslikes,
  liked,
  desliked,
  updateDb = () => {},
}) {
  const [totalLikes, setTotalLikes] = useState(likes || 0);
  const [totalDeslikes, setTotalDeslikes] = useState(deslikes || 0);
  const [like, setLike] = useState(liked || false);
  const [deslike, setDeslike] = useState(desliked || false);

  useEffect(() => {
    setTotalLikes(likes);
    setTotalDeslikes(deslikes);
    setLike(liked);
    setDeslike(desliked);
  }, [likes, deslikes, liked, desliked]);

  const handleLike = () => {
    if (deslike) {
      // remove deslike
      setTotalDeslikes(totalDeslikes - 1);
      updateDb({ remove: "dislike" });
    }

    if (like) {
      // remove like
      setTotalLikes(totalLikes - 1);
      updateDb({ remove: "like" });
    } else {
      // add like
      setTotalLikes(totalLikes + 1);
      updateDb({ like: true });
    }

    setLike(!like);
    setDeslike(false);
  };

  const handleDeslike = () => {
    if (like) {
      // remove like
      setTotalLikes(totalLikes - 1);
      updateDb({ remove: "like" });
    }

    if (deslike) {
      // remove deslike
      setTotalDeslikes(totalDeslikes - 1);
      updateDb({ remove: "dislike" });
    } else {
      // add deslike
      setTotalDeslikes(totalDeslikes + 1);
      updateDb({ like: false });
    }
    setDeslike(!deslike);
    setLike(false);
  };

  return (
    <div className="flex justify-around">
      <button
        type="button"
        onClick={handleDeslike}
        className="flex flex-col items-center"
      >
        <HeartBroken outline={!deslike} color={deslike ? "#FF5B68" : "white"} />
        <span className="text-sm">{totalDeslikes}</span>
      </button>
      <button
        type="button"
        onClick={handleLike}
        className="flex flex-col items-center"
      >
        <Heart outline={!like} color={like ? "#FF5B68" : "white"} />
        <span className="text-sm">{totalLikes}</span>
      </button>
    </div>
  );
}
